import { DefaultState, Filters } from 'store/types';

export const GET_EXPORT_JOBS_REQUEST = 'GET_EXPORT_JOBS_REQUEST';
export const GET_EXPORT_JOBS_SUCCESS = 'GET_EXPORT_JOBS_SUCCESS';
export const GET_EXPORT_JOBS_FAILURE = 'GET_EXPORT_JOBS_FAILURE';

export interface GetExportJobsParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  };
  sorting: {
    id: string;
    order: string;
  };
}

export interface GetExportJobsRow {
  id: string;
  createdAt: string;
  createdBy: string;
  type: string;
  recordsCount: number;
  status: string;
  completedAt?: string;
  downloadLink?: string;
  errorMessage?: string;
}

export interface GetExportJobsData {
  rows: GetExportJobsRow[];
  totalCount: number;
}

export type GetExportJobsState = DefaultState & {
  contents?: GetExportJobsData;
};

interface GetExportJobsRequest {
  type: typeof GET_EXPORT_JOBS_REQUEST;
}

interface GetExportJobsSuccess {
  type: typeof GET_EXPORT_JOBS_SUCCESS;
  contents: GetExportJobsData;
}

interface GetExportJobsFailure {
  type: typeof GET_EXPORT_JOBS_FAILURE;
}

export type GetExportJobsActionTypes =
  | GetExportJobsRequest
  | GetExportJobsSuccess
  | GetExportJobsFailure;
